import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import CountUp from "react-countup";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import './style.css';
import './bootstrap.min.css';
function Home() {
    const location = useLocation();
    const [index, setIndex] = useState(-1);

    // 1. Update Document Metadata
    useEffect(() => {
        document.title = "Unicell USA | Global Industrial & Project Development Solutions";
        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) {
            metaDesc.setAttribute('content', "Unicell USA offers expert solutions in paper mills, plastic recycling, and biomass energy with over 50 years of global experience.");
        }
    }, [location]);

    // 2. Initialize Owl Carousels (requires jQuery and OwlCarousel in your index.html)
useEffect(() => {
    const timer = setTimeout(() => {
        // 1. Bootstrap Carousel-ஐ தானாக இயங்க வைக்க
        if (window.bootstrap && document.getElementById('header-carousel')) {
            const myCarousel = new window.bootstrap.Carousel(document.getElementById('header-carousel'), {
                interval: 3000, // 3 seconds logic
                ride: 'carousel',
                pause: false // மவுஸ் மேலே கொண்டு சென்றாலும் நிக்காது
            });
            myCarousel.cycle();
        }

        // 2. Client Logo Carousel (Vendor Carousel) - ஒரு முறை மட்டும்
        if (window.$ && window.$(".vendor-carousel").length > 0) {
            window.$(".vendor-carousel").owlCarousel({
                loop: true,
                margin: 45,
                dots: false,
                autoplay: true,
                autoplayTimeout: 2000, // லோகோக்கள் 2 செகண்டிற்கு ஒருமுறை மாறும்
                smartSpeed: 1000,
                responsive: {
                    0: { items: 2 },
                    576: { items: 4 },
                    768: { items: 6 },
                    992: { items: 8 }
                }
            });
        }
    }, 500); // 1000ms-க்கு பதில் 500ms போதும்

    return () => clearTimeout(timer);
}, []);
   


    

    const galleryImages = [
        { src: "img/Zambi.png", title: "Zambia Operations" },
        { src: "img/swaziland.png", title: "Swaziland Project" },
        { src: "img/uae.png", title: "UAE Facility" },
        { src: "img/alpa.png", title: "Alpha Polyplast" },
        { src: "img/usa.png", title: "USA Plant" },
        { src: "img/sa.png", title: "South Africa Site" },
        { src: "img/tt.png", title: "Trinidad & Tobago" }
    ];

    return (
        <>
            {/* Header Carousel Start */}
              <div id="header-carousel" className="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="3000">
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img className="w-100" src="img/ban4.png" alt="Unicell Industrial" />
                        <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                            <div className="p-3" style={{ maxWidth: "900px" }}>
                                <h5 className="text-white text-uppercase mb-3 animated slideInDown">Global Leaders in Manufacturing</h5>
                                <h1 className="display-6 display-md-4 display-lg-2 text-white animated zoomIn">Sustainable Industrial Solutions</h1>
                                <Link to="/Contactus" className="btn btn-primary py-md-3 px-md-5 animated slideInRight">Contact Us <i className="bi bi-arrow-right ms-2"></i></Link>
                            </div>
                        </div>
                    </div>
                    <div className="carousel-item">
                        <img className="w-100" src="img/ban5.jpg" alt="Paper Mill" />
                        <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                            <div className="p-3" style={{ maxWidth: "900px" }}>
                                <h5 className="text-white text-uppercase mb-3 animated slideInDown">Over 50 Years Experience</h5>
                                <h1 className="display-6 display-md-4 display-lg-2 text-white animated zoomIn">Innovation in Paper & Recycling</h1>
                                <Link to="/Services" className="btn btn-primary py-md-3 px-md-5 animated slideInRight">Our Services <i className="bi bi-arrow-right ms-2"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#header-carousel" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#header-carousel" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>

            {/* Facts Section */}

             <div className="container-fluid facts py-5 pt-lg-0">
                <div className="container py-5 pt-lg-0">
            < div className="row gx-0">


                <div className="col-lg-4 wow zoomIn" data-wow-delay="0.3s">
                    <div className="bg-light shadow  align-items-center justify-content-center p-4" style={{height: "180px",display: "grid"}}>
                        <div className="ps-4">
                            <h5 className="text-primary mb-0" style={{textAlign:"center"}}>Skilled Jobs created over the years</h5>
                        </div>
                        <div className="bg-primary d-flex align-items-center justify-content-center rounded mb-2" style={{width: "160px", height: "60px",margin:"auto"}}>
                            <h1 className="mb-0 text-white"><CountUp end={3000} duration={3} />+</h1>


                        </div>
                       
                    </div>
                </div>
                <div className="col-lg-4 wow zoomIn" data-wow-delay="0.1s">
                   
                    <div className="bg-primary shadow align-items-center justify-content-center p-4" style={{height: "180px",display: "grid"}}>
                        <h5 className="text-white mb-0" style={{textAlign:"center"}}>Years of working experience</h5>

                        <div className="bg-white d-flex align-items-center justify-content-center rounded mb-2" style={{width: "160px", height: "60px",margin:"auto"}}>
                            
                            {/* <h1 class="mb-0" data-toggle="counter-up">50</h1><h1 class="mb-0">+</h1> */}
                              <h1 className="mb-0"><CountUp end={50} duration={3} />+</h1>

                        </div>
                      
                    </div>
                   
                </div>
                <div className="col-lg-4 wow zoomIn" data-wow-delay="0.3s">
                    <div className="bg-light shadow  align-items-center justify-content-center p-4" style={{height: "180px",display: "grid"}}>
                        <h5 className="text-primary mb-0" style={{textAlign:"center"}}>World projects designed, built, operated</h5>
                        <div className="bg-primary d-flex align-items-center justify-content-center rounded mb-2" style={{width: "160px", height: "60px",margin:"auto"}}>
                          <h1 className="mb-0 text-white"><CountUp end={8} duration={3} />+</h1>

                        </div>
                       
                    </div>
                </div>
             
                
            </div>
        </div>
    </div>
           

            {/* About Section */}
            <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
                <div className="container py-5">
                    <div className="row g-5">
                        <div className="col-lg-7">
                            <div className="section-title position-relative pb-3 mb-5">
                                <h5 className="fw-bold text-primary text-uppercase">About Us</h5>
                                <h1 className="mb-0">The best solutions with over 40 years of experience</h1>
                            </div>
                            <p className="mb-4">The Unicell team has operated diversified businesses, with a core competency in paper manufacture in which they have been involved for over 5 decades. At various times, the Unicell team has built Greenfield paper mill operations in South Africa, Swaziland, Zambia, United Arab Emirates (U.A.E), USA and Trinidad & Tobago. 
                            </p>
                            <p className="mb-4">The plants built by the Group on many different continents illustrates deep technical, operating and marketing abilities in the paper, plastic, recycling and related industries. Unicell has assembled highly skilled team of people in different disciplines over many years. Unicell has also forayed into:
                            </p>
                            <p className="mb-4">

                                Renewable Biomass and Alternative power generation projects.

                            </p>
                            <p className="mb-4">Carbon sequestration through reafforestation and afforestation projects.</p>
                            <p className="mb-4">International consulting and project development.</p>
                            <p className="mb-4">International Trading of industrial chemicals, raw materials and general trading.</p>

                            
                            <p className="bb-4">Plastic Recycling and Material recovery projects.
                            </p>
                            <marquee><p className="text-primary me-3">Above services are available for opportunities and offerings on the African continent and Indian ocean islands market. </p>
                            </marquee>
                          
                            <div className="d-flex align-items-center mb-4 wow fadeIn" data-wow-delay="0.6s">
                                <div className="bg-primary d-flex align-items-center justify-content-center rounded" style={{width: "60px", height: "60px"}}>
                                    <i className="fa fa-phone-alt text-white"></i>
                                </div>
                                <div className="ps-4">
                                    <h5 className="mb-2">E-mail us with your questions</h5>
                                    <h6 className="text-primary mb-0">gsharma@unicellusa.com</h6>
                                    <h6 className="text-primary mb-0">Info@unicellusa.com</h6>

                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5" style={{minHeight: "500px"}}>
                            <div className="position-relative h-100">
                                <img className="position-absolute w-100 h-100 rounded wow zoomIn" data-wow-delay="0.9s" src="img/about.jpg" style={{objectFit: "cover"}} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>



          <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
                <div className="container py-5">
                    <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{ maxWidth: "600px" }}>
                        <h5 className="fw-bold text-primary text-uppercase">Our Values</h5>
                        <h1 className="mb-0">Exponential growth through core values</h1>
                    </div>
                    <div className="row g-4">
                        <div className="col-lg-6">
                            <div className="card border-0 shadow p-4 h-100">
                                <h4 className="text-primary border-bottom pb-2">Vision</h4>
                                <ul className="list-unstyled mt-3">
                                    <li className="mb-2"><i className="bi bi-check-circle-fill text-primary me-2"></i> World-class project development company.</li>
                                    <li className="mb-2"><i className="bi bi-check-circle-fill text-primary me-2"></i> Sustaining profitable and sustainable growth.</li>
                                    <li><i className="bi bi-check-circle-fill text-primary me-2"></i> First choice for high-quality, cost-competitive projects.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="card border-0 shadow p-4 h-100">
                                <h4 className="text-primary border-bottom pb-2">Mission</h4>
                                <ul className="list-unstyled mt-3">
                                    <li className="mb-2"><i className="bi bi-check-circle-fill text-primary me-2"></i> Inspiring work environments to unleash creativity.</li>
                                    <li><i className="bi bi-check-circle-fill text-primary me-2"></i> Respected corporate citizen ensuring green processes.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>




       







        


            {/* Services Section */}
           <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
            <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{maxWidth: "600px"}}>
                <h5 className="fw-bold text-primary text-uppercase">Our Services</h5>
                <h1 className="mb-0">Best Solutions for Your Business</h1>
            </div>
            <div className="row g-5">
                <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.3s">
                    <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                        <div className="service-icon mt-4">
                             <img src="img/paper.png" style={{width:"50px"}} className="img-responsive" alt="" />
                        </div>
                        <h4 className="mb-3">Paper mills</h4>
                        <p className="m-0">Specializing in setting up complete tissue and Kraft packaging paper mills.</p>
                        <a className="btn btn-lg btn-primary rounded" href="">
                            <i className="bi bi-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
                    <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                        <div className="service-icon">
                            <img src="img/tissue-box.png" style={{width:"50px"}} className="img-responsive" alt="" />
                        </div>
                        <h4 className="mb-3">Tissue Paper</h4>
                        <p className="m-0">Hygienic tissue paper converting plants.</p>
                        <a className="btn btn-lg btn-primary rounded" href="">
                            <i className="bi bi-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.9s">
                    <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                        <div className="service-icon mt-4">
                            <img src="img/plastic.png" className="img-responsive" style={{width:"50px"}}  alt="" />

                        </div>
                        <h4 className="mb-3">Plastic</h4>
                        <p className="m-0">Plastic recycling and upcycling business to produce downstream added value products.</p>
                        <a className="btn btn-lg btn-primary rounded" href="">
                            <i className="bi bi-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.3s">
                    <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                        <div className="service-icon mt-4">
                            <img src="img/biomass.png" className="img-responsive" style={{width:"50px"}} alt="" />

                        </div>
                        <h4 className="mb-3">Biomass energy</h4>
                        <p className="m-0">Biomass energy power plants – Using natural and waste biomass to generate power.</p>
                        <a className="btn btn-lg btn-primary rounded" href="">
                            <i className="bi bi-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
                    <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                        <div className="service-icon">
                            <img src="img/free-trade.png" className="img-responsive" style={{width:"50px"}} alt="" />

                        </div>
                        <h4 className="mb-3">International Trading</h4>
                        <p className="m-0">Unicell is involved with raw material and general trading of commodities.</p>
                        <a className="btn btn-lg btn-primary rounded" href="">
                            <i className="bi bi-arrow-right"></i>
                        </a>
                    </div>
                </div>

                <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
                    <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                        <div className="service-icon mt-4">
                            <img src="img/garbage.png" className="img-responsive" style={{width:"50px"}}  alt="" />

                        </div>
                        
                        <h4 className="mb-3">Municipal waste</h4>
                        <p className="m-0">Waste in all countries and communities have serious consequences if not handled well.</p>
                        <a className="btn btn-lg btn-primary rounded" href="">
                            <i className="bi bi-arrow-right"></i>
                        </a>
                        
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.9s">
                    
                </div>

                <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.9s">
                    <div className="position-relative bg-primary rounded h-100 d-flex flex-column align-items-center justify-content-center text-center p-5">
                        <h3 className="text-white mb-3">Email us with your Query</h3>
                        <p className="text-white mb-3">Send us a email and will respond promptly</p>

                        <h5 className="text-white mb-0">gsharma@unicellusa.com</h5>
                        <h5 className="text-white mb-0">Info@unicellusa.com </h5>

                    </div>
                </div>

                <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.9s">
                    
                </div>
            </div>
        </div>
    </div>



          {/* Milestone Section */}

        <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
            <div className="container py-5">
                <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{maxWidth: "600px"}}>
                    <h5 className="fw-bold text-primary text-uppercase">Milestones</h5>
                </div>
            <div className="container">
            <ul className="timeline">
              <li className="event">
                <div className="left-arrow"></div>
                <div className="time">1979<span className="glyphicon glyphicon-time"></span></div>
                <h3>Zambia</h3>
                <div className="description"><p>Zambezi Paper Mills Ltd - Kraft & Tissue paper mill commissioned and operating to date. Circular business with high impact on ESG</p></div>
              </li>
              <li className="event">
                <div className="left-arrow"></div>
                <div className="time">1986<span className="glyphicon glyphicon-time"></span></div>
                <h3>Swaziland</h3>
                <div className="description"><p>Swazi Paper Mills Ltd - Kraft & Tissue paper mill constructed with full capacity attained at 85,000 tons per year.</p></div>
              </li>
              <li className="event">
                <div className="left-arrow"></div>
                <div className="time">1995<span className="glyphicon glyphicon-time"></span></div>
                <h3>United Arab Emirates</h3>
                <div className="description"><p>Emirates Paper Mills Ltd - commissioned with state of the art Tissue paper mill producing virgin tissue at 20,000 tons / year</p></div>
              </li>
              <li className="event">
                <div className="left-arrow"></div>
                <div className="time">2000<span className="glyphicon glyphicon-time"></span></div>
                <h3>United States of America</h3>
                <div className="description"><p>Unicell Paper Mills, Inc - Greenfield tissue mill installed in Florida state with high technology Tissue paper mill producing virgin tissue at 25,000 tons / year</p></div>
              </li>
              <li className="event">
                <div className="left-arrow"></div>
                <div className="time">2001<span className="glyphicon glyphicon-time"></span></div>
                <h3>South Africa</h3>
                <div className="description"><p>Unicell Paper Mills (SA) Pty Ltd - Kraft mill installed at this site in Germiston, Johannesburg to produce recycled kraft of capacity 75,000 tons / year.</p></div>
              </li> <li className="event">
                <div className="left-arrow"></div>
                <div className="time">2003<span className="glyphicon glyphicon-time"></span></div>
                <h3>Trinidad & Tobago</h3>
                <div className="description"><p>Unicell Paper Mills Caribbean Ltd - Greenfield project installed high technology crescent former tissue mill with 35,000 tons / year capacity to use virgin and recycled fibers.</p></div>
              </li> <li className="event">
                <div className="left-arrow"></div>
                <div className="time">2018<span className="glyphicon glyphicon-time"></span></div>
                <h3>Zambia</h3>
                <div className="description"><p>Alpha Polyplast Ltd – A waste bottle recycling project installed with high quality European machinery to recycle waste bottles into Polyester strapping for the regional export market. Circular business with high impact on ESG.</p></div>
              </li> <li className="event">
                <div className="left-arrow"></div>
                <div className="time">2022<span className="glyphicon glyphicon-time"></span></div>
                <h3>Mauritius</h3>
                <div class="description"><p>Consulted on a greenfield Wastepaper recycling project to manufacture Kraft Packaging papers for corrugated boxes using local wastepaper. Circular business with high impact on ESG.</p></div>
              </li>
            </ul>
          </div>
          </div>
      </div>




      


            {/* Lightbox Gallery */}
            <div className="container-fluid py-5">
                <div className="container">
                    <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{ maxWidth: "600px" }}>
                        <h5 className="fw-bold text-primary text-uppercase">Gallery</h5>
                        <h1 className="mb-0">Our Global Footprint</h1>
                    </div>
                    <div className="row g-4">
                        {galleryImages.map((img, idx) => (
                            <div key={idx} className="col-md-4 col-sm-6">
                                <div className="portfolio-item" onClick={() => setIndex(idx)} style={{ cursor: "pointer" }}>
                                    <img src={img.src} className="img-fluid rounded shadow" alt={img.title} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <Lightbox
                    index={index}
                    open={index >= 0}
                    close={() => setIndex(-1)}
                    slides={galleryImages.map(img => ({ src: img.src }))}
                />
            </div>

           {/* Team Section */}
            <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
                <div className="container py-5">
                    <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{ maxWidth: "600px" }}>
                        <h5 className="fw-bold text-primary text-uppercase">Team Members</h5>
                        <h1 className="mb-0">Professional Staff Ready to Help Your Business</h1>
                    </div>
                    <div className="row g-4">
                        {[
                            { name: "Girish Sharma", role: "Managing Director" },
                            { name: "Nisha Sharma", role: "Director" },
                            { name: "Josia Kamanga", role: "Head of Finance" },
                            { name: "Naomi Kabinda", role: "Head of Human Resource" },
                            { name: "Ganesh Mariyappan", role: "Head of Engineering" },
                            { name: "Lenny Banda", role: "Assistant Accountant" }
                        ].map((member, index) => (
                            <div key={index} className="col-lg-4 col-md-6 wow slideInUp" data-wow-delay={`${0.3 * (index % 3 + 1)}s`}>
                                <div className="team-item bg-light rounded overflow-hidden text-center py-4 shadow-sm">
                                    <h4 className="text-primary">{member.name}</h4>
                                    <p className="text-uppercase m-0">{member.role}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Clientele Section */}
            <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
                <div className="container py-5">
                    <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{ maxWidth: "600px" }}>
                        <h5 className="fw-bold text-primary text-uppercase">Our Clientele</h5>
                    </div>
                    <div className="bg-white p-4 border border-primary rounded">
                        <div className="owl-carousel vendor-carousel">
                            <img src="img/wecycle.jfif" alt="Client" />
                            <img src="img/inside.jfif" alt="Client" />
                            <img src="img/glg_logo.jfif" alt="Client" />
                            <img src="img/ZAFFICO.jpg" alt="Client" />
                            <img src="img/mantle_lab.jfif" alt="Client" />
                            <img src="img/shar.png" alt="Client" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Home;